import React, { useState } from 'react';
import importacaoService from '../services/importacaoService';
import toast from 'react-hot-toast';

export default function RegistrarPagamentoModal({ isOpen, onClose, importacaoId, onSucesso }) {
  const [dataPagamento, setDataPagamento] = useState(new Date().toISOString().split('T')[0]);
  const [tipo, setTipo] = useState('FRETE_OUTROS');
  const [valor, setValor] = useState('');
  const [observacao, setObservacao] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!valor || Number(valor) <= 0) {
      toast.error('O valor deve ser maior que zero');
      return;
    }

    setLoading(true);
    try {
      await importacaoService.registrarPagamento(importacaoId, { 
        dataPagamento,
        tipo,
        valor: Number(valor),
        observacao: observacao 
      });
      toast.success('Pagamento registrado com sucesso!');
      setValor('');
      setObservacao('');
      setTipo('FRETE_OUTROS');
      setDataPagamento(new Date().toISOString().split('T')[0]);
      onSucesso();
      onClose();
    } catch (err) {
      toast.error('Erro ao registrar pagamento');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 z-[60] flex justify-center items-center p-4 backdrop-blur-md">
      <div className="bg-white rounded-2xl p-8 w-full max-w-md shadow-2xl animate-in fade-in zoom-in duration-300">
        <h3 className="text-xl font-black mb-6 text-gray-900 border-b pb-4">Registrar Pagamento Real</h3>
        <form onSubmit={handleSubmit} className="space-y-5">
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Data</label>
              <input
                type="date"
                required
                value={dataPagamento}
                onChange={(e) => setDataPagamento(e.target.value)}
                className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-green-500 font-mono text-sm"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Categoria</label>
              <select
                required
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
                className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-lg shadow-sm focus:ring-2 focus:ring-green-500 text-sm font-semibold text-gray-700"
              >
                <option value="SINAL_30">Sinal (30%)</option>
                <option value="SALDO_70">Saldo (70%)</option>
                <option value="IMPOSTOS_DESEMBARACO">Impostos / Custo Nac.</option>
                <option value="FINIMP_30_PARCELA">Parcela Finimp (Entrada)</option>
                <option value="FINIMP_70_PARCELA">Parcela Finimp (Saldo)</option>
                <option value="FRETE_OUTROS">Frete / Outros Custos</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Valor Efetivado (R$)</label>
            <div className="relative">
              <span className="absolute left-3 top-2.5 text-gray-400 font-black">R$</span>
              <input
                type="number"
                step="0.01"
                required
                autoFocus
                value={valor}
                onChange={(e) => setValor(e.target.value)}
                className="block w-full pl-10 pr-3 py-2 text-lg border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-green-500 font-mono font-black text-green-700"
                placeholder="0.00"
              />
            </div>
          </div>
          
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Observação (Opcional)</label>
            <input
              type="text"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-green-500 text-sm"
              placeholder="Ex: Ref. Nota Fiscal 001, Pago via Pix..."
            />
          </div>

          <div className="flex justify-end gap-3 pt-6 mt-6 border-t border-gray-100">
            <button 
              type="button" 
              onClick={onClose} 
              className="px-5 py-2 text-gray-500 font-bold hover:bg-gray-100 rounded-xl transition-colors"
            >
              Cancelar
            </button>
            <button 
              type="submit" 
              disabled={loading}
              className="bg-green-600 text-white px-6 py-2 rounded-xl font-black shadow-lg shadow-green-200 hover:bg-green-700 active:scale-95 disabled:bg-gray-400 disabled:scale-100 transition-all flex items-center justify-center min-w-[140px]"
            >
              {loading ? 'Gravando...' : 'Registrar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}